

function Mentions() {
  return (
    <div className="mentions-container">
      <h1>Mentions légales</h1>
      <p><strong>Hébergeur :</strong> Netlify</p>
      <p><strong>SIRET :</strong> 93469337500016</p>
      <p><strong>SIREN :</strong> 934693375</p>
        <p><strong>RNA :</strong> W811009887</p>
      <p><strong>OBJET :</strong> Accompagner les jeunes passionnés dans l'élaboration de leurs projets audiovisuels et proposer une initiation aux métiers de la culture.</p>
      <div className="mentions-law">
        <p>
          Texte de loi des associations de 1901 : L'association est la convention par laquelle deux ou plusieurs personnes mettent en commun, d'une façon permanente, leurs connaissances ou leur activité dans un but autre que de partager des bénéfices. Elle est régie, quant à sa validité, par les principes généraux du droit applicables aux contrats et obligations.
        </p>
      </div>
      <p className="mentions-author">Site Web fait par Sophie Bartoli.</p>
    </div>
  );
}

export default Mentions;